import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IRemoveHandoverQueueItemRepoResponse = IRepoResponse<200> | IRepoResponse<400 | 500, string>;

export type IRemoveHandoverQueueItemRepo = IRepo<[{ queueId: number | string; declarationId: number | string }], IRemoveHandoverQueueItemRepoResponse>;

export const RemoveHandoverQueueItemRepoType = Symbol.for('RemoveHandoverQueueItemRepo');

@bind(RemoveHandoverQueueItemRepoType)
export class RemoveHandoverQueueItemRepo implements IRemoveHandoverQueueItemRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute({ queueId, declarationId }) {
    try {
      const result = await this.httpClient.post({ url: urlMaker('/api/admin/handover/cancelitem', { handover_task_id: queueId, declaration_id: declarationId }) });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400 || result.status === 422) {
        return {
          status: 400 as 400,
          response: Object.values(result.data.errors).flat().join('. '),
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
